<div class="container">
  <ion-grid class="login new-account ion-padding">
    <ion-row>
      <ion-col class="login-page-info">
        <h2 class="message">{{title}}</h2>
        <section class="perfil-info-button" style="padding-left: 20px; padding-right: 20px;">
          <ion-button (click)="confirm()" class="contratar" expand="block">Sim</ion-button>
          <ion-button (click)="deny()" class="offer" expand="block">Não</ion-button>
        </section>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>